import angular from 'angular';
import { BlipStoreController } from './BlipStoreController';
import BlipStoreView from './BlipStoreView.html';
import { ExternalBlipStoreService } from './ExternalBlipStoreService';
import { applicationListStateName } from 'modules/application/list';
import { BlipStoreFeatures } from './BlipStoreFeatures';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { blipStoreScriptSource } from 'app.constants';
export const blipStoreStateName = 'auth.blipStore';
export const blipStoreStateExtensionsName = 'auth.blipStore.extensions';
export const blipStoreStateExtensionsDetail = 'auth.blipStore.extension';
export const blipStoreTemplateStateName = 'auth.blipStore.template';
export const blipProfilerFilterState = 'auth.blipStore.filter';
export const blipStoreSubscriptionStateName = 'auth.blipStore.subscription';
export const blipStoreStateExtensionsManage = 'auth.blipStore.extensions.manage';
export default angular
    .module('blipStore', ['ui.router'])
    .service('ExternalBlipStoreService', ExternalBlipStoreService)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(blipStoreStateName, {
            url: '/blip-store',
            controller: BlipStoreController,
            controllerAs: '$ctrl',
            template: BlipStoreView,
            resolve: {
                authorization: fetchBlipStorePermission,
            },
            onEnter: () => {
                return MicroFrontendService.addSource(blipStoreScriptSource);
            },
        })
            .state(blipStoreStateExtensionsName, {
            url: '/extensions?collection=HighlightEvolveTheBlipDeskExperiencePlugins',
            controllerAs: '$ctrl',
            template: BlipStoreView,
            resolve: {
                authorization: fetchBlipStorePermission,
            },
        })
            .state(blipStoreStateExtensionsDetail, {
            url: '/extensions/{id:any}',
            controllerAs: '$ctrl',
            template: BlipStoreView,
            resolve: {
                authorization: fetchBlipStorePermission,
            },
        })
            .state(blipStoreSubscriptionStateName, {
            url: '/plugins/{id:any}/subscription',
            params: { hideFooter: true },
            resolve: {
                authorization: fetchBlipStorePermission,
            },
        })
            .state(blipStoreStateExtensionsManage, {
            url: '/manage',
            controllerAs: '$ctrl',
            template: BlipStoreView,
            resolve: {
                authorization: fetchBlipStorePermission,
            },
        })
            .state(blipStoreTemplateStateName, {
            url: '/{path:any}',
            resolve: {
                authorization: fetchBlipStorePermission,
            },
        });
    }]).name;
const fetchBlipStorePermission = ['$state', 'InitializeUserService', 'AccountService2', async function ($state, InitializeUserService, AccountService2) {
        await AccountService2.waitForInitialization();
        await InitializeUserService.initFeatureToggle();
        const isBlipStoreEnabled = await BlipStoreFeatures.isBlipStoreEnabled();
        if (!isBlipStoreEnabled) {
            $state.go(applicationListStateName);
        }
    }];
